import { ThreeDotsMenu } from '../../../components/ThreeDotsMenu'
import { AdditionalValuesMenu } from './Menu'
import { EmptyState } from './EmptyState'
import './styles.scss'
import { TAdditionalValuesWidget } from '../types'
import Typography from '../../../components/Typography/Typography'
import { TOptionsWithValueLabelResponse } from '../../../constants'
import { TYPOGRAPHY_WEIGHT } from '../../../components/Typography'
import { currencyFormatter } from '../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'

type AdditionalValuesProps = {
  data: TAdditionalValuesWidget
  typesList: TOptionsWithValueLabelResponse[]
}

export const AdditionalValues = ({
  data,
  typesList
}: AdditionalValuesProps) => {
  return (
    <div className="additional-values-block half-width charts_ongoing-contracts_container">
      <div className="row space-between align-center additional-values-block__header">
        <div className="charts_title">Additional values</div>
        <ThreeDotsMenu className="actual-saving-menu">
          <AdditionalValuesMenu />
        </ThreeDotsMenu>
      </div>

      {Object.keys(data)?.length ? (
        <div className="mt-8 additional-values-content">
          {Object.entries(data).map(([key, value]) => {
            return (
              <div className="row space-between align-center full-width additional-values-row">
                <Typography.Body2 className="additional-values-row__title">
                  {typesList.find((t) => t.value === key)?.label || '-'}
                </Typography.Body2>
                <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
                  ${currencyFormatter(value)}
                </Typography.Body2>
              </div>
            )
          })}
        </div>
      ) : (
        <EmptyState />
      )}
    </div>
  )
}
